import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";

/**
 * Cómo se pinta un involucrado, en un solo lugar.
 *
 * La misma persona aparece en el tab Información de la denuncia, en los
 * resultados del buscador de denuncias y en los de investigaciones; se ve igual
 * en los tres porque los tres leen de aquí.
 */

/**
 * El identificador se captura junto al involucrado (FormInputInvolved) y se
 * guarda como `identifier` + `identifier_type`. El tipo se nombra para que un
 * "GD93043" suelto se entienda; uno que no conozcamos se muestra sin etiqueta
 * en vez de inventarle una.
 */
const IDENTIFIER_LABEL_KEYS = {
  soeid: "involved.soeid",
  client_number: "involved.client_number",
};

/**
 * Color por tipo de involucrado. Son los mismos que usa la pestaña de
 * Investigación (useConstants → involvedsKindInfo), para que un sujeto se vea
 * rojo en todos lados y nadie estrene su propia paleta.
 */
export const useInvolvedColors = () => {
  const theme = useTheme();

  return {
    victim: theme.palette.info.main,
    witness: theme.palette.success.main,
    offender: theme.palette.red.main,
    accomplice: theme.palette.blueGray600.main,
  };
};

/** Sujeto, Cómplice, Afectado, Testigo. Un tipo desconocido se muestra tal cual. */
export const useInvolvedTypeLabel = () => {
  const [tInvestigation] = useTranslation("investigation");

  return (type) => (type ? tInvestigation(`involved.${type}`, type) : "");
};

/** "Gergina de Valdemar (Ejecutivo) · SOEID GD93043" */
export const useInvolvedDetail = () => {
  const [tInvestigation] = useTranslation("investigation");

  return (item = {}) => {
    // El puesto es opcional: sin él no tiene caso pintar unos paréntesis vacíos
    let detail = item.occupation
      ? `${item.name} (${item.occupation})`
      : item.name || "";

    if (item.identifier) {
      const labelKey = IDENTIFIER_LABEL_KEYS[item.identifier_type];
      const label = labelKey ? `${tInvestigation(labelKey)} ` : "";
      detail = `${detail} · ${label}${item.identifier}`;
    }

    return detail;
  };
};
